<template>
  <div class="table">
    <el-table
      data-test="table"
      :data="itemsForTable"
      style="width: 100%">
      <div slot="empty">{{ $t('emptyStateLabel') }}</div>
      <el-table-column
        v-for="col in columns"
        :key="col.key"
        data-test=""
        :label="col.label"
        :prop="col.key"
        :sortable="col.sortable"
        :sortBy="col.sortBy"
      >
        <!-- Display Column Header -->
        <template slot="header">
          <span :data-test="`table__col-${col.key}__header`">
            {{ col.label}}
          </span>
        </template>

        <!-- Display Column's rows -->
        <template slot-scope="scope">
          <div
            :data-test="`table__col-${col.key}__row-${scope.row.id}`"
            :data-test-cy="`table__col-${col.key}`">
            <!-- Default type -->
            <span
              v-if="!col.type"
              :style="col.style ? col.style(scope, scope.row) :''">
              {{ scope.row[col.key] }}
            </span>
            <span
              v-if="col.type === 'i18n'"
              :style="col.style ? col.style(scope, scope.row) :''">
              {{ $t(scope.row[col.key]) }}
            </span>
            <el-button
                v-if="col.type === 'button'"
                :type="col.buttonConfig.type"
                :size="col.buttonConfig.size"
                @click="col.buttonConfig.onClick(scope, scope.row, $router)">
              {{ col.buttonConfig.buttonText }}
            </el-button>
            <div v-if="col.type === 'buttons'">
              <el-button
                  v-for="(buttonConfig, key) in col.buttonsConfig"
                  :key="key"
                  :type="buttonConfig.type"
                  :size="buttonConfig.size"
                  @click="buttonConfig.onClick(scope, scope.row, $router)">
                {{ buttonConfig.buttonText }}
              </el-button>
            </div>
            <el-link
              v-if="col.type === 'link'"
              :type="col.linkConfig.type"
              @click="col.linkConfig.onClick(scope, scope.row, $router)">
              {{ $t(scope.row[col.key]) }}
              <i class="el-icon-view el-icon--right"></i>
            </el-link>
            <el-tag
              v-if="col.type === 'tag'"
              :size="col.tagConfig.size"
              :type="col.tagConfig.type(scope, scope.row)">
              {{ col.tagConfig.content(scope, scope.row, vm) }}
            </el-tag>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      v-if="paginable"
      style="margin-top: 50px;"
      background
      layout="prev, pager, next, sizes"
      :total="totalItemsToPaginate"
      :current-page="canPaginate.currentPage"
      :page-sizes="[20, 50, 100, 300]"
      :page-size="canPaginate.pageSize"
      @size-change="canPaginateSetPageSize"
      @current-change="canPaginateSetCurrentPage">
    </el-pagination>
  </div>
</template>
<script>
import canPaginate from '@/mixins/canPaginate';

export default {
  mixins: [canPaginate],
  props: {
    columns: { type: Object, default: () => ({}) },
    data: { type: Array, default: () => ([]) },
    paginable: { type: Boolean, default: false },
  },
  watch: {
    paginatedItems(value) {
      console.log('VALUE', value.length);
      console.log('CANPAGINATE?', this.canPaginateGetPaginatedItems(
        this.itemsToPaginate,
        this.canPaginate.currentPage,
        this.canPaginate.pageSize,
      ));
    },
  },
  computed: {
    vm() {
      return this;
    },
    itemsForTable() {
      // if the component uses pagination, we return paginated items
      // else we pass the data to the table :)
      if (this.paginable) {
        return this.paginatedItems;
      }
      return this.itemsToPaginate;
    },
    itemsToPaginate() {
      return this.data;
    },
  },
};
</script>
<style lang="lang" scoped>
</style>
